import GaodeDistrictType from './gaode_district_type.vue';

export default GaodeDistrictType;
